import { useEffect, useState } from 'react';
import { finesService } from '../services/finesService';

/*
 * Ejar auto-sync status, shared by every component that shows it (Dashboard, notifications).
 * One request every 5 minutes for the whole app, however many components subscribe.
 */
const POLL_MS = 5 * 60 * 1000;
let cached = null;
let lastFetch = 0;
let timer = null;
let inflight = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(cached));

function load(force = false) {
    if (inflight) return inflight;
    if (!force && cached && Date.now() - lastFetch < POLL_MS - 1000) return Promise.resolve(cached);
    inflight = finesService.ejarStatus()
        .then((s) => {
            cached = s;
            lastFetch = Date.now();
            notify();
            return s;
        })
        .catch(() => cached)
        .finally(() => { inflight = null; });
    return inflight;
}

export default function useEjarStatus() {
    const [status, setStatus] = useState(cached);

    useEffect(() => {
        listeners.add(setStatus);
        load();
        if (!timer) timer = setInterval(() => load(true), POLL_MS);
        return () => {
            listeners.delete(setStatus);
            if (listeners.size === 0 && timer) {
                clearInterval(timer);
                timer = null;
            }
        };
    }, []);

    return { status, refresh: () => load(true) };
}
